import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OccupationalProfileChartsComponent} from "./occupational-profile-charts.component";
import {ConfigModule} from "../config/config.module";

@NgModule({
    imports: [
        CommonModule,
        ConfigModule
    ],
    providers: [
    ],
    declarations: [
        OccupationalProfileChartsComponent
    ],
    exports: [
        OccupationalProfileChartsComponent
    ]
})

export class ChartsModule {

}
